import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

import { displaySize } from '../config';

export default styled(Icon)`
  font-size: ${displaySize};
  transform: scaleX(-1);
`;
